import reports from "./reports.component";
import reportsUrls from "./reports.urls";
import ReportsTransforms from "./reports.transforms";

const reportsModule = angular
  .module("app.components.reports", [])
  .component("reportsPage", reports)
  .service("ReportsTransforms", ReportsTransforms)
  .config(reportsUrls);

export default reportsModule;



// WEBPACK FOOTER //
// ./src/pages/reports/reports.module.js